var _rect, _text, _text2, _line, _path, _g, _g2, _text3, _text4, _text5, _line2, _text6, _line3, _text7, _line4, _text8, _text9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase3Fig3CatalogTrajectory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 640",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 640,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "The dated catalog series")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "Live plays at each snapshot, with the largest single day and the deliberate freeze marked.")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 500,
    x2: 1140,
    y2: 500,
    stroke: "#D4DDD6",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 493.2 H228.9 V438.9 H337.8 V357.4 H446.7 V346.5 H555.6 V307.1 H664.4 V298.9 H773.3 V193 H882.2 V145.4 H991.1 V144.1 H1100 V140 H1140",
    fill: "none",
    stroke: "#16A34A",
    strokeWidth: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#16A34A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 493.2,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.9,
    cy: 438.9,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.8,
    cy: 357.4,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446.7,
    cy: 346.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555.6,
    cy: 307.1,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 664.4,
    cy: 298.9,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.3,
    cy: 193,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 882.2,
    cy: 145.4,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 991.1,
    cy: 144.1,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 140,
    r: 3.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 485
  }, "5"), /*#__PURE__*/React.createElement("text", {
    x: 234.9,
    y: 430.9
  }, "45"), /*#__PURE__*/React.createElement("text", {
    x: 343.8,
    y: 349.4
  }, "105"), /*#__PURE__*/React.createElement("text", {
    x: 452.7,
    y: 338.5
  }, "113"), /*#__PURE__*/React.createElement("text", {
    x: 561.6,
    y: 299.1
  }, "142"), /*#__PURE__*/React.createElement("text", {
    x: 670.4,
    y: 290.9
  }, "148"), /*#__PURE__*/React.createElement("text", {
    x: 779.3,
    y: 185
  }, "226"), /*#__PURE__*/React.createElement("text", {
    x: 888.2,
    y: 137.4
  }, "261"), /*#__PURE__*/React.createElement("text", {
    x: 997.1,
    y: 136.1
  }, "262"), /*#__PURE__*/React.createElement("text", {
    x: 1106,
    y: 132
  }, "265"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 234.9,
    y: 456,
    fontSize: 11,
    fill: "#6B7F74"
  }, "launch, day 8")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 240,
    fontSize: 12,
    fontWeight: 600,
    fill: "#DC2626"
  }, "+78 in a single day")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 258,
    fontSize: 11.5,
    fill: "#4A5F56"
  }, "exhausted the database transfer quota")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 712,
    y1: 250,
    x2: 768,
    y2: 246,
    stroke: "#DC2626",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 755,
    y: 105,
    fontSize: 12,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "frozen by choice, 2026-07-06")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 945,
    y1: 110,
    x2: 988,
    y2: 137,
    stroke: "#6B7F74",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 925,
    y: 178,
    fontSize: 12,
    fontWeight: 600,
    fill: "#16A34A"
  }, "the documented supply run")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1095,
    y1: 172,
    x2: 1112,
    y2: 148,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 528,
    fontSize: 11,
    fill: "#6B7F74"
  }, "snapshots in sequence order, evenly spaced; the axis is not time. The +78 rise happened inside one day,")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 544,
    fontSize: 11,
    fill: "#6B7F74"
  }, "and the flat run from 262 to 265 spans three quiet weeks after the freeze")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase3Fig3CatalogTrajectory);
export default __webpack_public_path__ + "static/media/case3-fig3-catalog-trajectory.ac8c5e7753fce43ab9a0e7d6f7dbe927.svg";
export { ForwardRef as ReactComponent };